import {isShippingToChinaWithTaxEnabled} from '../../../selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import store from '../../../store/store';

const chineseMobileNumberError = 'errors.formFields.chinese.mobile.number';

const chineseMobileNumberRegex = /^[0-9]{11}$/;
export const isChineseMobileNumber = value => !!value.match(chineseMobileNumberRegex);

export const chineseMobileNumberShippingToChinaWithTaxEnabled = (value) => {
  if (!value) return;

  const strippedValue = value.replace(/\s/g, '');

  if (!strippedValue) return;

  if (isShippingToChinaWithTaxEnabled(store.getState())) {
    if (!isChineseMobileNumber(strippedValue)) return chineseMobileNumberError;
  }
};
